export function sexLabel(value: string | null | undefined): string {
  if (value === "F" || value === "여성") return "여성";
  if (value === "M" || value === "남성") return "남성";
  return "미상";
}
